<template>
		<!-- Footer -->
		<footer class="footer footer-five">
		
			<!-- Footer Top -->
			<div class="footer-top aos" data-aos="fade-up">
				<div class="container">
					<div class="row">
						<div class="col-lg-3 col-md-6">
							<!-- Footer Widget -->
							<div class="footer-widget">
								<div class="footer-logo">
									<a href="#"><img src="@/assets/img/footerlogo.svg" alt="logo"></a>
								</div>
								<div class="footer-content">
									<p>Lörem ipsum od ohet dilogi. Bell trabel, samuligt, ohöbel utom diska. Jinesade bel när feras redorade i belogi. FAR paratyp i muvåning, och pesask vyfisat. </p>
								</div>	
								<div class="social-icon">
									<ul>
										<li>
											<a href="#" target="_blank"><i class="fab fa-facebook-f"></i> </a>
										</li>
										<li>
											<a href="#" target="_blank"><i class="fab fa-twitter"></i> </a>
										</li>
										<li>
											<a href="#" target="_blank"><i class="fab fa-instagram"></i></a>
										</li>
										<li>
											<a href="#" target="_blank"><i class="fab fa-linkedin-in"></i></a>
										</li>
									</ul>
                                </div>
							</div>
							<!-- /Footer Widget -->
						</div>
						<div class="col-lg-2 col-md-6">
							<!-- Footer Widget -->
							<div class="footer-widget footer-menu">
								<h2 class="footer-title">Pages</h2>
								<ul>
									<li>
										<a href="javascript:void(0)">Market Place</a>
									</li>
									<li>
										<a href="javascript:void(0)">Documentaion</a>
									</li>
									<li>
										<a href="javascript:void(0)">Customers</a>
									</li>
									<li>
										<a href="javascript:void(0)">Carrers</a>
									</li>
									<li>
										<router-link to="blog-list">Our Blog</router-link>
									</li>									
								</ul>
							</div>
							<!-- /Footer Widget -->
						</div>
						<div class="col-lg-2 col-md-6">
							<!-- Footer Widget -->
							<div class="footer-widget footer-menu">
								<h2 class="footer-title">Categories</h2>
								<ul>
									<li>
										<a href="javascript:void(0)">Restaurant</a>
									</li>
									<li>
										<a href="javascript:void(0)">Beauty</a>
									</li>
									<li>
										<a href="javascript:void(0)">Fitness</a>
									</li>
									<li>
										<a href="javascript:void(0)">Night Life</a>
									</li>
									<li>
										<a href="javascript:void(0)">Shopping</a>
									</li>									
								</ul>
							</div>
							<!-- /Footer Widget -->
						</div>
						<div class="col-lg-2 col-md-6">
							<!-- Footer Widget -->
							<div class="footer-widget footer-menu">
								<h2 class="footer-title">Top Cities</h2>
								<ul>
									<li>
										<a href="javascript:void(0)">Manhattan</a>
									</li>
									<li>
										<a href="javascript:void(0)">Los Angeles</a>
									</li>
									<li>
										<a href="javascript:void(0)">Houston</a>
									</li>
									<li>
										<a href="javascript:void(0)">Chicago</a>
									</li>
									<li>
										<a href="javascript:void(0)">Alabama</a>
									</li>									
								</ul>
							</div>
							<!-- /Footer Widget -->
						</div>
						<div class="col-lg-3 col-md-6">
							<!-- Footer Widget -->
							<div class="footer-widget">
								<h2 class="footer-title">Communication</h2>
								<div class="footer-contact-info">
									<div class="footer-address">
										<i class="feather-phone me-2"></i>
										<p> (406) 555-0120	 </p>
									</div>
									<div class="footer-address">
										<i class="feather-mail me-2"></i>
										<p> listee@example.com	 </p>
									</div>
									<div class="footer-address">
										<i class="feather-map-pin me-2"></i>
										<p> 2972 Westheimer Rd. Santa Ana, Illinois 85486 	 </p>
									</div>
								</div>																
							</div>
							<!-- /Footer Widget -->							
						</div>
					</div>
				</div>
			</div>
			<!-- /Footer Top -->
						
			<!-- Footer Bottom -->
			<div class="footer-bottom">
				<div class="container">
					<!-- Copyright -->
					<div class="copyright">
						<div class="row">
							<div class="col-md-12">
								<div class="copyright-text text-center">
									<p class="mb-0">2023 &copy; Listee. All rights reserved.</p>
								</div>
							</div>
						</div>
					</div>
					<!-- /Copyright -->
				</div>
			</div>
			<!-- /Footer Bottom -->
			
		</footer>
		<!-- /Footer -->
</template>